import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import { LanguageCodeEnum } from '@systemeio/types';
import { getLocaleByLanguageCode } from '@systemeio/util';
import { useLanguageSwitcher } from 'shared/components/language-switcher/hooks/use-language-switcher';
import { LanguageSwitcher } from 'shared/components/language-switcher/language-switcher';
import { DESKTOP_NAVBAR_CHEVRON_CHILD_CLASS_NAME, MOBILE_NAVBAR_ITEM_CLASS_NAME } from 'shared/components/navbar/constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { twJoin } from 'tailwind-merge';
interface LanguageMenuProps {
  isDesktop: boolean;
}
export function LanguageMenu(t0) {
  const $ = _c(14);
  const {
    isDesktop
  } = t0;
  const {
    i18n
  } = useLocoTranslation();
  const {
    isLoading
  } = useUser();
  const {
    handleChangeLanguage,
    isChangingLanguage
  } = useLanguageSwitcher();
  if (isLoading || !i18n) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton className="h-8 w-13 rounded-md" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = i18n.language as LanguageCodeEnum;
  let t2;
  if ($[1] !== t1) {
    t2 = getLocaleByLanguageCode(t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const selectedLanguage = t2;
  const t3 = isDesktop ? "label" : "name";
  const t4 = isDesktop && DESKTOP_NAVBAR_CHEVRON_CHILD_CLASS_NAME;
  const t5 = !isDesktop && MOBILE_NAVBAR_ITEM_CLASS_NAME;
  const t6 = !isDesktop && "hover:bg-transparent";
  let t7;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = twJoin(t4, t5, t6);
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== handleChangeLanguage || $[8] !== isChangingLanguage || $[9] !== isDesktop || $[10] !== selectedLanguage || $[11] !== t3 || $[12] !== t7) {
    t8 = <LanguageSwitcher selectedLanguage={selectedLanguage} changeLanguage={handleChangeLanguage} isFetching={isChangingLanguage} labelType={t3} openOnHover={isDesktop} dataTestId="change-language-button" buttonClassName={t7} />;
    $[7] = handleChangeLanguage;
    $[8] = isChangingLanguage;
    $[9] = isDesktop;
    $[10] = selectedLanguage;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}